import { Dimensions } from 'react-native';
export var isScreenSmall = function () {
    return Dimensions.get("window").width < 650;
};
